module.exports = __webpack_public_path__ + "img/demidova.7c936381.jpg";